export default __webpack_public_path__ + "static/4_match-card-334a11539bc5484c2050b421879574ef.png";